import { render, staticRenderFns } from "./all-services-CN.vue?vue&type=template&id=b2313ba2&"
import script from "./all-services-CN.vue?vue&type=script&lang=js&"
export * from "./all-services-CN.vue?vue&type=script&lang=js&"
import style0 from "./all-services-CN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports